import { NsjAuthInstance } from '@core/authentication/nsj-autenticacao';
import { NsjRoutingInstance } from '@core/routing/nsj-rotas';

/**
 * Cliente HTTP do painel administrativo. As rotas saem do fosrouting (nomes admin_painel_administrativo_*)
 * e o token vai cru no Authorization, como no resto do Meu RH. Diferente do httpClient do core, devolve
 * a mensagem do corpo da resposta — é ela que explica o erro em PT-BR.
 */
export class PainelAdministrativoApiError extends Error {
    constructor(message: string, public status: number) {
        super(message);
        Object.setPrototypeOf(this, PainelAdministrativoApiError.prototype);
    }
}

type Metodo = 'GET' | 'POST' | 'PUT';

class PainelAdministrativoApi {

    url(rota: string, params: object = {}): string {
        return NsjRoutingInstance.Routing.generate(rota, params as any, true);
    }

    get<T>(rota: string, params: object = {}): Promise<T> {
        return this.request<T>('GET', this.url(rota, params));
    }

    post<T>(rota: string, params: object = {}, body: any = {}): Promise<T> {
        return this.request<T>('POST', this.url(rota, params), body);
    }

    put<T>(rota: string, params: object = {}, body: any = {}): Promise<T> {
        return this.request<T>('PUT', this.url(rota, params), body);
    }

    private async request<T>(metodo: Metodo, url: string, body?: any): Promise<T> {
        let response: Response;

        try {
            response = await fetch(url, {
                method: metodo,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': NsjAuthInstance.nsjAuth.token
                },
                body: metodo === 'GET' ? undefined : JSON.stringify(body)
            });
        } catch (e) {
            throw new PainelAdministrativoApiError('Não foi possível conectar à API do Meu RH.', 0);
        }

        let dados: any = null;
        try {
            dados = await response.json();
        } catch (e) {
            dados = null;
        }

        if (!response.ok) {
            throw new PainelAdministrativoApiError(this.mensagemDeErro(response.status, dados), response.status);
        }

        return dados as T;
    }

    private mensagemDeErro(status: number, dados: any): string {
        if (status === 401 || status === 403) {
            return 'Seu usuário não tem acesso ao painel administrativo. É preciso estar no grupo de acesso '
                + '"APIs administrativas MeuRH" do Diretório (permissão interno_meurh).';
        }

        if (dados && typeof dados.message === 'string' && dados.message) {
            return dados.message;
        }

        return `Erro inesperado (HTTP ${status}).`;
    }
}

export const painelAdministrativoApi = new PainelAdministrativoApi();
